import { createStyles } from '@material-ui/core';

const styles = () => createStyles({
  button: {
    '& > button': {
      width: '100%',
    },
  },
});

export default styles;
